export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：≥10分钟</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<p class="text-line">1.选手解锁飞行器后，飞行计时开始。</p>'+
  '<p class="text-line">2.竞赛飞行轨迹</p>'+
  '<div class="text-line"><p class="line-l-text">科目①：</p><p class="line-r-text">起飞，由起降平台起飞至安全高度，穿过圆圈飞向科目②； </p></div>'+
  '<div class="text-line"><p class="line-l-text">科目②：</p><p class="line-l-text">在飞行高度低于标杆高度上限的前提下，逆时针方向(俯视角度) 环绕一圈，飞向科目③；</p></div>'+
  '<div class="text-line"><p class="line-l-text">科目③：</p><p class="line-l-text">无人机从横杆下部穿越，沿顺时针方向(竞赛选手站位视角)环绕横杆一周，经横杆下部飞向科目④；</p></div>'+
  '<div class="text-line"><p class="line-l-text">科目④：</p><p class="line-l-text">首先从上向下穿越高位圆圈④A，然后从下向上穿越低位圆圈④B， 之后飞向科目⑤；</p> </div>'+
  '<div class="text-line"><p class="line-l-text">科目⑤：</p><p class="line-l-text">按照⑤A-⑤B-⑤C 的先后顺序，连续穿越蛇形连环圈，共三个，之后飞向科目⑥；</p></div>'+
  '<div class="text-line"><p class="line-l-text">科目⑥：</p><p class="line-l-text">飞回起降平台上空，在起降平台安全降落。飞机降落后，选手操作锁桨，桨叶停止转动，计时停止。</p></div>'+
  '<img class="img-line" src="/work/static/img/uva/XGF/t25.jpg" width="100%" />' +
  '<h3 class="h3-line">飞行示意</h3>'+
  '<img class="img-line" src="/work/static/img/uva/XGF/t26.jpg" width="100%" />' +
  '</div>'
}